import z, { useState as G, useEffect as K } from "react";
import j from "./index79.mjs";
import { useAtomValue as t, useSetAtom as W } from "jotai";
import { Loader as U } from "./index11.mjs";
import Y from "./index116.mjs";
import { calculateTotalPrice as J } from "./index111.mjs";
import { shouldShowCityTaxItem as Q, getValidCityTaxAmount as X } from "./index117.mjs";
import { addTrackingHash as S, removeTrackingHash as Z } from "./index118.mjs";
import { CONFIRM_LOADING_HASH as $, CONFIRMED_HASH as tt } from "./index87.mjs";
import { track as T } from "./index9.mjs";
import { TRACK_EVENT_TYPE as E, TRACK_EVENT as h } from "./index10.mjs";
import { cartItemsAtom as et, giftCardsAtom as ot, giftCardCodeAtom as rt, roomsAvailabilityAtom as it } from "./index34.mjs";
import { clientDetailsAtom as nt } from "./index55.mjs";
import { setCurrentStepAtom as at } from "./index25.mjs";
import { totalAdultsAtom as mt, totalChildrenAtom as st, arrivalDateAtom as ct, departureDateAtom as lt } from "./index26.mjs";
import { getInsuranceSelectedAtom as pt, insurancePriceAtom as ut } from "./index62.mjs";
import { getDaysDifference as dt, formatDateISO8601 as b } from "@amenitiz/design-system";
import { useAlert as _t } from "./index119.mjs";
import { useBookingSummaryShow as ft } from "./index120.mjs";
import { useErrorAlert as gt } from "./index121.mjs";
import { useErrorHandler as yt, ErrorType as At } from "./index122.mjs";
import { useHotelConfig as It } from "./index93.mjs";
import { usePayment as Ct } from "./index123.mjs";
import { useResetStore as St } from "./index124.mjs";
import { getABoostValue as Tt } from "./index21.mjs";
import { getSubscriptionPlanRoot as k } from "./index14.mjs";
const Jt = ({ onClose: p }) => {
  const [O, u] = G(!0), { setBookingSummaryShow: d } = ft(), i = t(et), _ = t(ot), N = t(rt), D = t(mt), v = t(st), n = t(ct), a = t(lt), R = t(it), m = t(pt), f = t(ut), x = n && a && dt(n, a), s = t(nt), H = W(at), { payment: g } = Ct(), P = _t(), c = gt(), y = St(), F = yt(), {
    hotelId: l,
    hotelName: B,
    propertySize: A,
    propertyType: I,
    subscriptionPlan: C,
    clientBookingToken: V
  } = It();
  return K(() => {
    const M = () => {
      let e = 1;
      return i.flatMap((o) => {
        const L = {
          item_name: o.roomName,
          item_id: e++,
          price: parseFloat(o.totalPrice),
          promo_code_added: o.promoCodeAdded,
          item_type: "Room",
          quantity: "1"
        }, q = [
          ...o.optionalExtras.map((r) => ({
            item_name: r.name,
            item_id: e++,
            price: parseFloat(r.total_price),
            item_type: "Optional Extra",
            quantity: r.amount
          })),
          ...o.mandatoryExtras.map((r) => ({
            item_name: r.name,
            item_id: e++,
            price: parseFloat(r.total_price),
            item_type: "Mandatory Extra",
            quantity: r.amount
          }))
        ], w = Q(
          o.cityTaxIncluded,
          o.cityTaxes
        ) ? [
          {
            item_name: "City Tax",
            item_id: e++,
            price: X(o.cityTaxes),
            item_type: "City Tax",
            quantity: "1"
          }
        ] : [];
        return [L, ...q, ...w];
      });
    };
    return S($), d(!1), u(!0), T(h.VIEW, E.CONFIRMATION_LOADING, {
      hotel_id: l,
      property_type: I,
      property_size: A,
      subscription_plan: k(C)
    }), j.createBooking(
      {
        ...i.length > 0 && { items: i },
        ..._.length > 0 && { gift_cards: _ },
        customer: s,
        payment: g,
        clientBookingToken: V,
        opted_for_insurance: m,
        gift_card_code: N
      },
      f
    ).then((e) => {
      if (!e.success)
        if (e.error_code && Object.values(At).includes(e.error_code)) {
          const o = F(
            e.error_code,
            H
          );
          return d(!0), c(o);
        } else
          return c();
      S(tt), T(
        h.PURCHASE,
        E.VIEW_BOOKING_CONFIRMATION,
        {
          hotel_id: l,
          property_type: I,
          property_size: A,
          subscription_plan: k(C),
          transaction_id: e.data.booking_id,
          adults: D,
          children: v,
          nights: x,
          insurance_selected: m ? "yes" : "no",
          currency: R.currency,
          value: J({
            cartItems: i,
            insurancePrice: m ? f : void 0
          }),
          ecommerce: {
            items: M()
          },
          items: [
            {
              item_id: l,
              item_name: B,
              item_category: n ? b(n) : null,
              item_category2: a ? b(a) : null,
              item_category3: s.email,
              item_variant: Tt("ads_source")
            }
          ]
        }
      ), P({
        icon: Y,
        title: I18n.t("booking_engine.information.booking_confirmed"),
        subTitle: I18n.t("booking_engine.information.send_booking_details"),
        onClose: () => {
          y(), p();
        },
        isShowCloseButton: !0,
        actions: [
          {
            label: I18n.t("booking_engine.global.done"),
            onClick: () => {
              y(), p();
            }
          }
        ]
      });
    }).catch(() => {
      c();
    }).finally(() => {
      u(!1);
    }), () => Z();
  }, [i, s, g]), O ? /* @__PURE__ */ z.createElement(U, { description: I18n.t("booking_engine.information.do_not_leave") }) : null;
};
export {
  Jt as FinalStep
};
